"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Entity_1 = __importDefault(require("../../Core/Entity"));
var DeliveryCatalogGEService_1 = __importDefault(require("../Service/DeliveryCatalogGEService"));
var servicePrefix = '/fleet-service';
var servicePrefixDeliveryProvider = '/delivery-provider-service';
var baseRouteProviders = "".concat(servicePrefixDeliveryProvider, "/v1/delivery-providers");
var baseRouteMerchant = "".concat(servicePrefixDeliveryProvider, "/v1/merchant/delivery-providers");
var baseMerchantConnections = "".concat(servicePrefixDeliveryProvider, "/v1/merchant-connections");
var baseRouteFleets = "".concat(servicePrefix, "/v1/fleets");
var ROUTES = {
    NOTIFICATION: "".concat(baseRouteMerchant, "/notify"),
    FLEETS: "".concat(baseRouteFleets, "/fleet"),
    FAVOURITES: {
        UPDATE: "".concat(baseRouteProviders, "/favorites"),
        LIST: "".concat(baseRouteProviders, "/favorites/list")
    },
    MERCHANT_CONNECTIONS: {
        LIST: "".concat(baseMerchantConnections, "/list"),
        CREATE: "".concat(baseMerchantConnections, "/create"),
        UPDATE: "".concat(baseMerchantConnections, "/update"),
        DELETE: "".concat(baseMerchantConnections, "/delete"),
        VERIFY: "".concat(baseMerchantConnections, "/verify"),
        PAUSE: "".concat(baseMerchantConnections, "/pause")
    }
};
var DeliveryCatalogEntity = /** @class */ (function (_super) {
    __extends(DeliveryCatalogEntity, _super);
    function DeliveryCatalogEntity(session) {
        var _this = _super.call(this, {
            session: session,
            entityName: 'fleet-service'
        }) || this;
        _this.deliveryCatalogGEService = new DeliveryCatalogGEService_1.default();
        return _this;
    }
    /** START General-ENV routes */
    DeliveryCatalogEntity.prototype.getProviders = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deliveryCatalogGEService.getProviders(payload)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryCatalogEntity.prototype.getDeliveryById = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deliveryCatalogGEService.getDeliveryById(payload)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryCatalogEntity.prototype.getFilters = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deliveryCatalogGEService.getFilters()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryCatalogEntity.prototype.getFiltersDetails = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deliveryCatalogGEService.getFiltersDetails(payload)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /** END General-ENV routes */
    /** Multi-ENV routes */
    DeliveryCatalogEntity.prototype.toggleFavorites = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.post(ROUTES.FAVOURITES.UPDATE).withPayload(payload).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryCatalogEntity.prototype.getUsersFavorites = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.post(ROUTES.FAVOURITES.LIST).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryCatalogEntity.prototype.sendEmailNotification = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.post(ROUTES.NOTIFICATION).withPayload(payload).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryCatalogEntity.prototype.getFleetById = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.post(ROUTES.FLEETS).withPayload(payload).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryCatalogEntity.prototype.getMerchantConnectionsList = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.post(ROUTES.MERCHANT_CONNECTIONS.LIST).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryCatalogEntity.prototype.createMerchantConnection = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.post(ROUTES.MERCHANT_CONNECTIONS.CREATE).withPayload(payload).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryCatalogEntity.prototype.updateMerchantConnection = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.post(ROUTES.MERCHANT_CONNECTIONS.UPDATE).withPayload(payload).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryCatalogEntity.prototype.deleteMerchantConnection = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.post(ROUTES.MERCHANT_CONNECTIONS.DELETE).withPayload(payload).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryCatalogEntity.prototype.verifyMerchantConnectionCredentials = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.post(ROUTES.MERCHANT_CONNECTIONS.VERIFY).withPayload(payload).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryCatalogEntity.prototype.pauseMerchantConnection = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.post(ROUTES.MERCHANT_CONNECTIONS.PAUSE).withPayload(payload).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return DeliveryCatalogEntity;
}(Entity_1.default));
exports.default = DeliveryCatalogEntity;
//# sourceMappingURL=DeliveryCatalogEntity.js.map